var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parse } from 'query-string';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateUserPageViewAction, apiUpdateUserPageViewAction, setUserPageViewIdAction, } from '@/actions/AnalyticsActions';
import { USE_PAGE_VIEW } from '@/define/env';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { createRandomStringId } from '@/utils/libs/uuid/createId';
export const usePageViewLog = (options) => {
    const { isIgnorePage, location, unmountRef } = options;
    const dispatch = useDispatch();
    const { pathname, search } = location;
    useEffect(() => {
        const apiDoingRef = { current: true };
        let intervalId = null;
        let latestApiId = null;
        const endCallback = () => {
            apiDoingRef.current = false;
            if (intervalId) {
                clearInterval(intervalId);
            }
            dispatch(setUserPageViewIdAction(null));
        };
        if (isIgnorePage || !USE_PAGE_VIEW) {
            return endCallback;
        }
        // ページビュー送信用のAPI呼び出し関数
        const sendPageViewLogApi = (apiOptions) => __awaiter(void 0, void 0, void 0, function* () {
            const currentApiId = createRandomStringId();
            latestApiId = currentApiId;
            const parameter = parse(apiOptions.search);
            const { clientHeight, scrollHeight, scrollTop } = document.documentElement;
            const scroll = Number.isNaN(scrollTop) ? 0 : scrollTop;
            const scrollParent = scrollHeight - clientHeight;
            const scrollPer = scrollParent
                ? Math.floor((scroll / scrollParent) * 100)
                : 100;
            const fixScrollPer = Math.max(Math.min(100, scrollPer), 0);
            const json = {
                parameter: parameter || {},
                path: apiOptions.pathname,
                scroll: fixScrollPer,
            };
            if (apiOptions.pageViewId) {
                yield wrapDispatch(dispatch, apiUpdateUserPageViewAction({ json, path: { id: apiOptions.pageViewId } }, {}));
                return null;
            }
            const result = yield wrapDispatch(dispatch, apiCreateUserPageViewAction({ json }, {}));
            if (latestApiId !== currentApiId) {
                return null;
            }
            return result.payload.id;
        });
        (() => __awaiter(void 0, void 0, void 0, function* () {
            // apiを実行
            const resultPageViewId = yield sendPageViewLogApi({
                pathname,
                search,
            });
            if (unmountRef.current || !apiDoingRef.current) {
                return;
            }
            if (resultPageViewId) {
                dispatch(setUserPageViewIdAction(resultPageViewId));
                let isDoing = false;
                intervalId = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
                    if (isDoing) {
                        return;
                    }
                    isDoing = true;
                    try {
                        yield sendPageViewLogApi({
                            pageViewId: resultPageViewId,
                            pathname,
                            search,
                        });
                    }
                    finally {
                        isDoing = false;
                    }
                }), 10 * 1000);
            }
        }))();
        return endCallback;
    }, [dispatch, pathname, search, unmountRef, isIgnorePage]);
    return {};
};
